var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardObol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5217 10.3438C20.4444 13.4503 19.3036 16.4021 16.3776 18.4128C11.0735 22.0671 3.68104 19.1605 2.23093 12.8766C1.50268 9.71862 1.79266 6.68302 3.64884 3.9568C5.7306 0.901899 8.74031 -0.335519 12.356 0.0769534C15.9136 0.482987 18.3434 2.51319 19.7355 5.79368C20.3026 7.14059 20.5088 8.5521 20.5217 10.3438ZM19.5163 9.81532C19.4648 9.33835 19.4325 8.66809 19.323 8.00423C19.2392 7.49507 19.0845 6.9988 18.9169 6.50903C16.861 0.59255 9.32687 -1.0058 5.19564 3.69262C2.48232 6.77971 2.22453 10.434 3.79703 14.1334C5.7757 18.7866 11.5052 20.443 15.688 17.633C18.3756 15.8413 19.4196 13.1538 19.5163 9.81532Z",
    fill: "#AA7D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8929 18.3355C1.7928 16.4793 0.0527166 13.8047 0.00111942 10.1439C-0.0504778 6.36069 1.68321 3.58298 4.8735 1.64301C2.35357 3.86006 1.11615 6.65078 1.11615 9.99566C1.12255 13.347 2.36646 16.1314 4.8929 18.3355Z",
    fill: "#AA7D50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4604 18.3227C22.6422 14.1978 22.5004 5.6776 17.4798 1.68176C19.7742 2.6421 22.2942 5.90319 22.4166 9.61554C22.5713 14.0884 19.6969 17.3559 17.4604 18.3227Z",
    fill: "#AA7D50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4902 11.2654V8.75186L11.3118 7.48865L9.12695 8.75186V11.2654L11.3118 12.5286L13.4902 11.2654Z",
    fill: "#AA7D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardObol);
export default __webpack_public_path__ + "static/media/reward_obol.f0bbdb4f1b8c725ba2db100a60f50ae8.svg";
export { ForwardRef as ReactComponent };